const USER_COOKIE_NAME = 'user';

export function clearUserCookie(): void {
  document.cookie = `${USER_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export function setUserCookie(value: object, expiresInDays = 3): void {
  const expiry = new Date();
  expiry.setDate(expiry.getDate() + expiresInDays);
  expiry.setHours(6, 0, 0, 0);
  document.cookie = `${USER_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(value))}; expires=${expiry.toUTCString()}; path=/`;
}
